/**
 * Lightbox (I) mit <dialog>: Fokus bleibt im Dialog, Esc schließt (nativ),
 * Pfeiltasten blättern. Bilder einer Gruppe = alle .lightbox-Links im selben
 * Inhaltselement bzw. Abschnitt. Ohne JS öffnet der Link einfach das Bild.
 */
export function initLightbox() {
  const links = [...document.querySelectorAll('a.lightbox')];
  if (!links.length || typeof HTMLDialogElement === 'undefined') return;

  const dialog = document.createElement('dialog');
  dialog.className = 'c-lightbox';
  dialog.setAttribute('aria-label', 'Bildansicht');
  dialog.innerHTML = `
    <img class="c-lightbox__img" alt="">
    <p class="c-lightbox__caption"><strong></strong><span></span></p>
    <button type="button" class="c-lightbox__btn c-lightbox__close" aria-label="Schließen">${icon('M6 6l12 12M18 6L6 18')}</button>
    <button type="button" class="c-lightbox__btn c-lightbox__prev" aria-label="Vorheriges Bild">${icon('M15 6l-6 6 6 6')}</button>
    <button type="button" class="c-lightbox__btn c-lightbox__next" aria-label="Nächstes Bild">${icon('M9 6l6 6-6 6')}</button>`;
  document.body.append(dialog);

  const img = dialog.querySelector('img');
  const [capText, capCount] = dialog.querySelectorAll('.c-lightbox__caption > *');
  const prev = dialog.querySelector('.c-lightbox__prev');
  const next = dialog.querySelector('.c-lightbox__next');
  let group = [];
  let index = 0;

  function show(i) {
    index = (i + group.length) % group.length;
    const link = group[index];
    const thumb = link.querySelector('img');
    img.src = link.href;
    img.alt = thumb?.alt || '';
    const caption = link.closest('figure')?.querySelector('figcaption')?.textContent.trim() || thumb?.alt || '';
    capText.textContent = caption;
    capCount.textContent = group.length > 1 ? `${index + 1} / ${group.length}` : '';
    prev.hidden = next.hidden = group.length < 2;
  }

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const scope = link.closest('.frame, .c-section, main');
      group = links.filter((l) => scope.contains(l));
      show(group.indexOf(link));
      dialog.showModal();
      dialog._opener = link;
    });
  });
  prev.addEventListener('click', () => show(index - 1));
  next.addEventListener('click', () => show(index + 1));
  dialog.querySelector('.c-lightbox__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', (e) => {
    if (group.length < 2) return;
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });
  dialog.addEventListener('close', () => dialog._opener?.focus());
}

function icon(d) {
  return `<svg class="c-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
}
